import { useState } from "react";

import config from "@/config";
import useDelayUnmount from "@/lib/hooks/useDelayUnmount";
import type { ISortOrder } from "@/types/centra";

import UI from "./UI";

interface SortMenuProps {
  sortOrder: ISortOrder;
}

const SortMenu = ({ sortOrder }: SortMenuProps) => {
  const [show, setShow] = useState(false);
  const toggleMenu = () => setShow(!show);
  const closeMenu = () => setShow(false);
  const shouldRender = useDelayUnmount(
    show,
    config.animationDurationModal * 1000
  );

  return (
    <UI
      toggleMenu={toggleMenu}
      closeMenu={closeMenu}
      show={show}
      sortOrder={sortOrder}
      shouldRender={shouldRender}
    />
  );
};

export default SortMenu;
